import './App.css';
import AllRoutes from './Routes/AllRoutes';
import { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from 'react-redux';
import SidePanel from './Components/CommonComponents/SidePanel';
import { ToastContainer, toast } from 'react-toastify';

function App() {
  const userLoginSuccess = useSelector((state) => state.AuthReducer.userLoginSuccess);

  useEffect(() => {
    toast.clearWaitingQueue();
    toast.dismiss();
    AOS.init();
  }, []);

  return (
    <div className='bg-slate-100 min-h-screen flex flex-col'>
      <div className={`Main flex-1 ${userLoginSuccess ? 'flex' : ''}`}>
        {userLoginSuccess && <SidePanel />}
        
        <div className="flex-1 flex flex-col min-w-0 overflow-x-hidden">
          <main className="flex-1">
            <AllRoutes />
          </main>
          
          {window.location.pathname !== '/' && (
            <footer className="py-3 px-6 text-center text-xs text-slate-500 border-t border-slate-200/80 mt-auto">
              <span>&copy; {new Date().getFullYear()} Shiven Consultancy Services. All rights reserved. </span>
              <span className="inline-block ml-1">
                Software maintained by{' '}
                <a
                  className="text-sky-600 hover:text-sky-800 font-medium hover:underline transition"
                  href="http://www.shiveninfotech.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  shiveninfotech.com
                </a>
              </span>
            </footer>
          )}
        </div>
      </div>
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        limit={2}
      />
    </div>
  );
}

export default App;
